// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3d0I_","requiredAsterisk":"Info_requiredAsterisk__2a1Z9"};